export default "/fonts/vendor/tinymce/skins/lightgray/tinymce.eot?b7f32c761cc0d4a73dc871320162b9b5";